import React, { useState } from 'react'
import { Helmet } from 'react-helmet';

import "../../Login.css"
import banner from '../../images/banners/collect.jpg'
import '../../Track.css';
import BACKEND_URL from '../../api';
import FaceRecognitionModal from './FaceRecognitionModal';

export default function Register_test() {
  const [register, setregister] = useState({
    username: '',
    email: '',
    first_name: '',
    last_name: '',
    phone_number: '',
    password: ''
  })
  const [loading, setLoading] = useState(false)

  const [passerror, setpasserror] = useState('')
  const [passsuccess, setpasssuccess] = useState('')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [capturedImage, setCapturedImage] = useState(null)

  const validatePhoneNumber = (number) => {
    const phoneRegex = /^(00|\+)?(\d{1,3})?\d{7,15}$/; // Regex to match the required formats
    return phoneRegex.test(number);
  };

  function checkpass(val) {
    console.log(register.password)
    if (val != register.password) {
      console.log('error');
      setpasserror('Incorrect email or password. Please try again.')
      setpasssuccess('')

    } else {
      setpasserror('')
    }
  }

  function submitregister() {
    let emailerror = 0;
    if (register.username != "" && register.password != "" && register.email != "" && register.phone_number != "") {
      if (validatePhoneNumber(register.phone_number)) {

        let lastAtPos = register.email.lastIndexOf("@");
        let lastDotPos = register.email.lastIndexOf(".");

        if (!(
          lastAtPos < lastDotPos &&
          lastAtPos > 0 &&
          register.email.indexOf("@@") == -1 &&
          lastDotPos > 2 &&
          register.email.length - lastDotPos > 2
        )) {
          emailerror = 1
          alert(register.email)
          setpasserror('Please enter a valid email id')
          setpasssuccess('')
        } else {
          setpasserror()
          emailerror = 0
        }
        if (emailerror == 0) {
          setLoading(true);

          fetch(`${BACKEND_URL}/register`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(register) // Convert `register` object to JSON string
          })
            .then((res) => {
              if (!res.ok) {
                throw new Error('Network response was not ok ' + res.statusText);
              }
              return res.json(); // Parse the JSON from the response
            })
            .then((data) => {
              console.log("register--------", data)
              if (data.code == 0) {
                setpasserror(data.message);
                setpasssuccess('')
              } else {
                // sessionStorage.setItem('userid', data.userid);
                setpasssuccess('Verification code sent. Please check your email to verify your email.');
              }
            })
            .catch((err) => console.log(err))
            .finally(() => {
              setLoading(false);
            });
        }

      } else {
        setpasserror('Please enter a valid phone number')
        setpasssuccess('')
      }

    } else {
      setpasserror("Enter Username, Password, Email and Phone Number")
      setpasssuccess('')
    }
  }

  return (
    <div>
      <Helmet>
        <title>Shypv | Register</title>
      </Helmet>
      <section className="your_business_page fw" style={{ backgroundImage: `url(${banner})`, backgroundAttachment: 'fixed', backgroundSize: 'cover' }}>
        <div className="container"><div className="row">
          <div className="col-md-12 col-sm-12 your_business text-center">
            <div className="business_content">
              <h2>REGISTER</h2>
            </div>
          </div>
        </div>
        </div>
      </section>

      <div className="pages_content">
        <div className="container">

          <div className="row">
            <div className="col-md-3"></div>
            <div className="col-md-6"
              style={{
                marginTop: "6%", // Existing top margin
                marginBottom: "6%", // Existing bottom margin
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)", // New shadow effect
                borderRadius: "8px", // Optional: add rounded corners
              }}
            >
              <div id="primary" className="content-area" style={{ float: 'left', padding: '10%', width: "100%" }}>
                <main id="main" className="site-main" role="main" style={{ textAlign: "center" }}>

                  <br />

                  <div>

                    <input type="text" placeholder='Username' className="form-control mb-3" style={{ borderRadius: "5px" }} required onChange={(e) => setregister({ ...register, username: e.target.value })} />

                    <input type="text" placeholder='Email' className="form-control  mb-3" style={{ borderRadius: "5px" }} required onChange={(e) => setregister({ ...register, email: e.target.value })} />
                    <input type="text" placeholder='First Name' className="form-control  mb-3" style={{ borderRadius: "5px" }} required onChange={(e) => setregister({ ...register, first_name: e.target.value })} />
                    <input type="text" placeholder='Last Name' className="form-control  mb-3" style={{ borderRadius: "5px" }} required onChange={(e) => setregister({ ...register, last_name: e.target.value })} />
                    <input type="text" placeholder='Phone Number' className="form-control  mb-3" style={{ borderRadius: "5px" }} required onChange={(e) => setregister({ ...register, phone_number: e.target.value })} />
                    <input type="password" placeholder='Password' className="form-control  mb-3" style={{ borderRadius: "5px" }} required onChange={(e) => setregister({ ...register, password: e.target.value })} />
                    <input type="password" placeholder='Confirm Password' className="form-control  mb-3" style={{ borderRadius: "5px" }} required onChange={(e) => checkpass(e.target.value)} />

                    <p style={{ color: 'red' }}>{passerror}</p>
                    <p style={{ color: 'purple' }}>{passsuccess}</p>
                    {/* <div className="submit-button" style={{marginBottom: "20px"}} onClick={() => setIsModalOpen(true)}>
                      <span>Face Recognition</span>
                    </div> */}
                    {
                      loading ? (
                        <div className="submit-button" onClick={submitregister}>
                          <span className="n-loader"></span><span>Loading...</span>
                        </div>
                      ) : (
                        <div className="submit-button" onClick={submitregister}>
                          <span>Sign Up</span>
                        </div>
                      )
                    }{capturedImage}

                    {
                      isModalOpen &&
                      <FaceRecognitionModal
                        onClose={() => setIsModalOpen(false)}
                        capturedImage={capturedImage}
                        setCapturedImage={(value) => setCapturedImage(value)}
                        mode="register"
                      />
                    }
                  </div>
                </main>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}
